module.exports = __webpack_public_path__ + "img/ValidateCheck.8970c334.svg";